import { render } from "./Department.vue?vue&type=template&id=01cedb37&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"

import "./Department.vue?vue&type=style&index=0&id=01cedb37&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01cedb37"

export default script